<template>
  <div class="devices d-flex flex-column align-self-center"> <!-- devices -->

    <div class="left-slider-right flex-column justify-content-center overflow-auto">

      <div class="d-flex flex-column">
        <h2 v-html="$t('devices.0.title')"></h2>
        <div class="intro-text d-flex">
          <p v-html="$t('devices.0.devices_intro')"></p>
        </div>
      </div>

      <div class="devices-device d-flex">
        <img src="@/assets/placeholders/gelddetector_ill.jpg">
        <div class="device-text d-flex flex-column">
          <h3>{{ $t("devices.1.title") }}</h3>
          <p v-html="$t('devices.1.content')"></p>
          <strong  class="price" v-html="$t('devices.1.price')"></strong>
          <p v-html="$t('devices.1.price_content')"></p>

        </div>
      </div>

      <div class="devices-device d-flex">
        <img src="@/assets/placeholders/geldteller_ill.jpg">
        <div class="device-text d-flex flex-column">
          <h3>{{ $t("devices.2.title") }}</h3>
          <p v-html="$t('devices.2.content')"></p>
          <strong  class="price" v-html="$t('devices.1.price')"></strong>
          <p v-html="$t('devices.2.price_content')"></p>
        </div>
      </div>

      <div class="devices-device d-flex">
        <img src="@/assets/placeholders/geldpen_ill.jpg">
        <div class="device-text d-flex flex-column">
          <h3>{{ $t("devices.3.title") }}</h3>
          <p v-html="$t('devices.3.content')"></p>
          <strong  class="price" v-html="$t('devices.1.price')"></strong>
          <p v-html="$t('devices.3.price_content')"></p>
        </div>
      </div>
      <div class="devices-end"/>
    </div>
  </div> <!-- /devices -->
</template>

<script>
export default {
};
</script>

<style scoped lang="scss">
  .devices {
    position: relative;
    max-width: 600px;
    height: auto;
    margin: 0 0 16px 0;
    .left-slider-right {
      margin: 36px 0 16px 0;
      @media (max-width: 576px) {
        margin: 32px 0 16px 0;
      }
      .intro-text p {
        font-size: 120%;
        line-height: 150%;
      }
      .devices-device {
        padding: 10px;
        border: 1px solid #9994c2;
        border-bottom: 0;
        max-width: 100%;
        flex-direction: row;
        @media (max-width: 576px) {
          flex-direction: column;
        }
        h2 {
          width: 100%;
          text-align: left;
        }
        h3 {
          margin-top: 12px;
        }
        img {
          max-width: 160px;
          max-height: 160px;
          margin: 0 10px 0 0;
        }
        .device-text {
          @media (max-width: 576px) {
            flex-direction: column;
          }
          p {
            max-width: auto;
            text-align: left;
            margin:0;
            @media (max-width: 576px) {
              margin-bottom: 0;
            }
          }
          .price {
            margin-top: 12px;
          }
        }
      }
      .devices-end {
        border-top: 1px solid #9994c2;
      }
    }
  }
</style>

<style lang="">
  .router-view {
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
  }
  .router-view::-webkit-scrollbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/devices.vue